export default __webpack_public_path__ + "static/media/BG.b0e59e45.svg";